import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

import { FiShoppingCart, FiZap } from 'react-icons/fi';
import toast from 'react-hot-toast';
import './ProductCard.css';

const NPR = (amount) =>
  'NPR ' + parseFloat(amount || 0).toLocaleString('en-NP', { minimumFractionDigits: 0 });

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  
  const img = product.images?.find((i) => i.is_primary) || product.images?.[0];

  const handleAddToCart = async (e) => {
    e.preventDefault();
    
    try {
      await addItem(product, 1, product.price);
      toast.success(`${product.title} added to cart`);
    } catch {
      toast.error('Failed to add item');
    }
  };

  return (
    <Link to={`/products/${product.slug}`} className="product-card">
      <div className="pc-image-wrap">
        {img ? (
          <img src={img.image} alt={img.alt || product.title} className="pc-image" loading="lazy" />
        ) : (
          <div className="pc-no-image"><FiZap /></div>
        )}
        {product.inventory === 0 && <div className="pc-out-of-stock">Out of Stock</div>}
        {product.inventory > 0 && product.inventory < 5 && (
          <div className="pc-low-stock">Only {product.inventory} left</div>
        )}
      </div>

      <div className="pc-body">
        {product.category && <span className="pc-category">{product.category}</span>}
        <h3 className="pc-title">{product.title}</h3>

        {/* DJI-specific specs */}
        {(product.max_flight_time || product.camera_sensor) && (
          <div className="pc-specs">
            {product.max_flight_time && <span>✈ {product.max_flight_time}</span>}
            {product.camera_sensor && <span>📷 {product.camera_sensor}</span>}
          </div>
        )}

        <div className="pc-footer">
          <div className="pc-price">{NPR(product.price)}</div>
          <button
            className="pc-cart-btn"
            onClick={handleAddToCart}
            disabled={product.inventory === 0}
            title="Add to cart"
          >
            <FiShoppingCart />
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;